import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 545DF72E-705C-46AC-BABE-94F6C304CFAB
 * name arrow-down-bold-box
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-bold-box.svg
 * tags
 * - Arrow 
 */
export const ArrowDownBoldBoxIcon = createSvgIcon(<><path d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M12,17L17,12H14V8H10V12H7L12,17Z" /></>, 'ArrowDownBoldBoxIcon');
export default ArrowDownBoldBoxIcon